import Vue from "vue";
import App from "./App.vue";
import router from "./router-player";

Vue.config.productionTip = false;

// Polyfills needed for iOS9 and VuePlyr.
// Note: This is for the Player version only!
// We're not supporting iOS9 in the authoring application.

if (!Object.entries)
  Object.entries = function(obj) {
    var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array

    while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];
    return resArray;
  };

const reduce = Function.bind.call(Function.call, Array.prototype.reduce);
const isEnumerable = Function.bind.call(
  Function.call,
  Object.prototype.propertyIsEnumerable
);
const concat = Function.bind.call(Function.call, Array.prototype.concat);
const keys = Reflect.ownKeys;

if (!Object.values) {
  Object.values = function values(O) {
    return reduce(
      keys(O),
      (v, k) =>
        concat(v, typeof k === "string" && isEnumerable(O, k) ? [O[k]] : []),
      []
    );
  };
}

if (!Object.entries) {
  Object.entries = function entries(O) {
    return reduce(
      keys(O),
      (e, k) =>
        concat(
          e,
          typeof k === "string" && isEnumerable(O, k) ? [[k, O[k]]] : []
        ),
      []
    );
  };
}

// End Polyfills

import shortkey from "vue-shortkey";
Vue.use(shortkey);

import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

if (process.env.NODE_ENV === "production") {
  // Only use Sentry in production builds.
  Sentry.init({
    dsn: "https://a762b24a55554c7b8055b5f5aef6a5ee@sentry.io/1440315",
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true
      })
    ],
    release: process.env.VUE_APP_GIT_REV
  });
}

// These are used in the editor AND the player.
// Make sure to add to main-editor and main-player.
import "vue-awesome/icons/link";
import "vue-awesome/icons/external-link-alt";
import "vue-awesome/icons/play";
import "vue-awesome/icons/pause";
import "vue-awesome/icons/info";

import Icon from "vue-awesome/components/Icon";

// globally (in your main .js file)
Vue.component("v-icon", Icon);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
